export default __webpack_public_path__ + "static/media/editpen.7f504e8e.svg";